import React from "react";
import HeroSection from "../../components/HeroSection";
import ProductSection from "../../components/ProductSection";

const Shop = () => {
  return (
    <div className="session_padding" style={{ paddingTop: "100px" }}>
      <HeroSection />
      <ProductSection />
    </div>
  );
};
export default Shop;
